import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import onahReducer, { OnahPersistConfig } from "../../persistor";
import { getNotifications, markNotification } from "services/common";
import { Notification } from "interface/notification";
import { uniq } from "underscore";


type NotificationProps = {
    page?: number;
    size?: number;
}

type NotificationState = {
    notifications: Array<Notification>;
    nextPage: number,
    page: number;
    size: number;
    totalItems: number;
    loading: boolean;
    error: boolean
}

const initialState: NotificationState = {
    notifications: [],
    page: 1,
    nextPage: 1,
    size: 40,
    totalItems: 0,
    loading: false,
    error: false,
}


export const fetchNotifications = createAsyncThunk('notifications/getNotifications', async (props: NotificationProps, thunkApi) => {
    const state = (thunkApi.getState() as any).notification as NotificationState;
    if(state.loading) {
        return {
            notifications: state.notifications,
            page: state.page,
            size: state.size,
            nextPage: state.nextPage,
            totalItems: state.totalItems,
        };
    }
    thunkApi.dispatch(setLoading());
    const {page = state.nextPage, size = state.size} = props;
    let notifications: Array<Notification> = [];
    const response = await getNotifications({
        page: page,
        limit: size,
    });
    if (response?.data?.notifications) {
        if(page === 1) {
            notifications =  uniq([...response.data!.notifications!, ...state.notifications], 'id');
        } else {
            notifications =  uniq([...state.notifications, ...response.data!.notifications!], 'id');
        }
        return {
            notifications: notifications,
            // nextPage: (page === 1 && state.nextPage >= 2) ? state.nextPage : state.page + 1,
            // page: (page === 1 && state.nextPage >= 2) ? state.nextPage : state.page,
            nextPage: state.page + 1,
            page:  state.page,
            size: state.size,
            totalItems:response?.data.meta?.totalItems!,
        };
    } else {
        return {
            notifications: state.notifications,
            page: state.page,
            size: state.size,
            totalItems: state.totalItems,
            nextPage: state.nextPage,
        };
    }
    
});

export const markNotificationRead = createAsyncThunk('notifications/markNotificationRead', async (notificationId: string, thunkApi) => {
    const response = await markNotification(notificationId);
    if(response) {
        return notificationId;
    }
});


export const notificationSlice = createSlice({
    name: "notification",
    initialState: initialState,
    reducers:{
        setLoading: (state) => {
            state.loading = true;
            state.error = false;
        }
    },
    extraReducers:(builders)=> {
        builders.addCase(fetchNotifications.fulfilled, (state, action) => {
            state.loading = false;
            if(action.payload) {
                state.notifications = action.payload.notifications;
                state.nextPage = action.payload.nextPage;
                state.page = action.payload.page;
                state.size = action.payload.size;
                state.totalItems = action.payload.totalItems;
            }
        });
        builders.addCase(fetchNotifications.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
        builders.addCase(markNotificationRead.fulfilled, (state, action) => {
            if(action.payload) {
                const notificationIndex = state.notifications.findIndex(notification => notification.id === action.payload)
                state.notifications[notificationIndex].status = 'READ';
            }
        });
    }
})
export const {setLoading} = notificationSlice.actions;

const authPersistConfig: OnahPersistConfig = {
    key: notificationSlice.name,
    blacklist: ['error', 'loading', 'page', 'totalItems']
}

export const notificationReducer = onahReducer(authPersistConfig,  notificationSlice.reducer, true);

export const notificationReducerPath = notificationSlice.name;